module.exports = __webpack_public_path__ + "img/br-alerts-phone.a025017e.png";